// extracted by mini-css-extract-plugin
export default {"diceHistory":"RollSuggestions_diceHistory__U4Yay","historyEntry":"RollSuggestions_historyEntry__mabQO"};